import DynamicFormField from "components/form/DynamicFormField";
import dayjs from 'dayjs';
import { useFetchData, useDownloadData } from "services/queries";
import { useParams } from "react-router-dom";
import { Button, FormControl } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { Menu, MenuItem, Hidden } from '@mui/material';
import React, { useEffect } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import MenuList from '@mui/material/MenuList';
import ListItemIcon from '@mui/material/ListItemIcon';
import Check from '@mui/icons-material/Check';
import Divider from '@mui/material/Divider';
import DownloadIcon from '@mui/icons-material/Download';
import getInputChange from "utils/handleInputChange";
import { useState } from "react";
import { useUpdateData, useFetchDataId, useCreateData } from "services/queries";
import { useNavigate } from "react-router-dom";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import toast from "react-hot-toast";
import CalculateIcon from '@mui/icons-material/Calculate';
import { ASSESSMENT_TYPE_CHOICES, TAX_REGIME_CHOICES } from "constants";
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot, TimelineOppositeContent } from '@mui/lab';
import { Typography } from '@mui/material';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import PaymentTermsAutocomplete, { OTHER_OPTION } from '../PaymentTermsAutocomplete';
import {
    timelineOppositeContentClasses,
} from '@mui/lab/TimelineOppositeContent';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ListItemText } from '@mui/material';

const TimelineComponent = ({ sales_order_id }) => {
    const { data: notes, error: errorNotes, isLoading: isLoadingNotes, refetch: refetchNotes } = useFetchData(`notes/note/?sales_order=${sales_order_id}`, true);
    const { data: productNotes, error: errorProductNotes, isLoading: isLoadingProductNotes, refetch: refetchProductNotes } = useFetchData(`notes/note/?sales_order__products=${sales_order_id}`, true);
    const { data: products, isLoading: isLoadingProducts, error: errorProducts } = useFetchData('product', true);

    // get order data
    const { data: order, error: errorOrder, isLoading: isLoadingOrder } = useFetchDataId('order/simple-sales-order', sales_order_id, true);
    const createNote = useCreateData('notes/note');

    const [formData, setFormData] = useState({ sales_order: sales_order_id });
    const handleInputChange = (e) => (getInputChange(e, formData, setFormData));

    const handleSave = () => {
        setFormData(() => ({ ...formData, sales_order: sales_order_id }));
        createNote.mutate(formData);
    };

    const formFields = [
        {
            id: "note",
            label: "Add New Note...",
            type: "textarea",
            mdColSpan: 12,
            handleInputChange,
            value: formData?.note
        },
        {
            id: "product",
            label: "Product - Optional",
            type: "select",
            options: products?.map(product => ({ value: product.id, label: `${product.sku} - ${product.name}` })),
            mdColSpan: 12,
            handleInputChange: handleInputChange,
            value: formData?.product
        }
    ]

    useEffect(() => {
        refetchNotes();
        setFormData(() => ({ sales_order: sales_order_id }));
    }, [notes, createNote.isSuccess]);
    if (isLoadingNotes || isLoadingProducts || isLoadingOrder || isLoadingProductNotes) {
        return <div>Loading...</div>;
    }
    if (errorNotes || errorProducts || errorOrder || errorProductNotes) {
        return <div>Error...</div>;
    }

    // concat notes and productNotes
    const notesData = [...notes, ...productNotes];
    // sort it by desc by created_at
    notesData.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    console.log("notesData: ", notesData);
    return (
        <>
            <Grid container spacing={2} margin={2} display="flex" justifyContent="center" alignItems="center">
                <Grid xs={12} md={11}>
                    {formFields.map(field => {
                        return (
                            <DynamicFormField
                                key={field.id}
                                field={field}
                                formData={formData}
                                mdColSpan={11}
                                handleInputChange={handleInputChange}
                            />
                        );
                    })}
                </Grid>
                <Grid item md={1}>
                    <Button onClick={handleSave} variant="contained" color="primary">
                        Add
                    </Button>
                </Grid>
            </Grid>
            <Timeline
                sx={{
                    [`& .${timelineOppositeContentClasses.root}`]: {
                        flex: 0.25,
                    },
                }}
            >
                {notesData.map((item, index) => (
                    <TimelineItem key={index}>
                        <TimelineOppositeContent color="text.secondary">
                            <Typography component="span" variant="button" display="block" margin={0}>
                                {item.created_by?.name}
                            </Typography>
                            <Typography variant="overline" display="block" >
                                {dayjs(item.created_at).format('YYYY-MM-DD HH:mm')}
                            </Typography>
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                            <TimelineDot color="secondary" />
                            <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent>

                            <Typography variant="caption" display="block" color="text.secondary">
                                {order.id === item.sales_order ? <span style={{ fontWeight: 'bold' }}>{order.order_identifier}</span> : ''}
                                {item.product && order.id === item.sales_order && ' - '}
                                {item.product && (
                                    <span style={{ fontStyle: 'italic' }}>
                                        {`${products.find(product => product.id === item.product)?.name || 'N/A'} [${products.find(product => product.id === item.product)?.sku || 'N/A'}]`
                                        }
                                    </span>
                                )}
                            </Typography>

                            <Typography sx={{ whiteSpace: 'pre-wrap' }}>
                                {item.note}
                            </Typography>
                        </TimelineContent>
                    </TimelineItem>
                ))}
            </Timeline>
        </>
    );
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function FullScreenDialog({ open, onClose, sales_order_id }) {


    const handleClose = () => {
        onClose();
    };

    return (
        <React.Fragment>
            <Dialog
                fullWidth
                maxWidth="md"
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            Notes
                        </Typography>
                        <Button autoFocus color="inherit" onClick={handleClose}>
                            Close
                        </Button>
                    </Toolbar>
                </AppBar>
                <TimelineComponent sales_order_id={sales_order_id} /> {/* Use your TimelineComponent here */}
            </Dialog>
        </React.Fragment>
    );
}

const OrderSale = () => {
    const simple_resource_path = 'order/simple-sales-order';
    const resource_path = 'order/sales-order';
    const { id } = useParams();
    const isEditMode = Boolean(id);
    const navigate = useNavigate();
    const { data: clients, isLoading: isLoadingClients, error: errorClients } = useFetchData('client', true);
    const { data: shippers, isLoading: isLoadingShippers, error: errorShippers } = useFetchData('shipper', true);
    const { data: statusSalesOrder, isLoading: isLoadingStatusSalesOrder, error: errorStatusSalesOrder } = useFetchData('order/status-sales-order', true);
    const { data: orderFiles, error: errorOrderFiles, isLoading: isLoadingOrderFiles, refetch: refetchOrderFiles } = useFetchData(`order/sales-order-files/?file_type=FULL&sales_order=${id}`, true, !!id);
    const { data: packingFiles, error: errorPackingFiles, isLoading: isLoadingPackingFiles, refetch: refetchPackingFiles } = useFetchData(`order/sales-order-files/?file_type=PL&sales_order=${id}`, true);
    const { data: invoiceFiles, error: errorInvoiceFiles, isLoading: isLoadingInvoiceFiles, refetch: refetchInvoiceFiles } = useFetchData(`order/sales-order-files/?file_type=CI&sales_order=${id}`, true);
    const { data: order, error: errorOrder, isLoading: isLoadingOrder } = useFetchDataId(simple_resource_path, id, true);
    const { data: users, error: errorUsers, isLoading: isLoadingUsers } = useFetchData('authentication/users', true);
    const { data: orderTypes, isLoading: isLoadingOrderTypes, error: errorOrderTypes } = useFetchData('order/order-types', true);
    const { data: tusRates, isLoading: isLoadingTusRates, error: errorTusRates } = useFetchData('tax/tus-rates', true);

    const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

    const [showNotes, setShowNotes] = useState(false);
    const toggleNotes = () => setShowNotes(!showNotes);


    const downloadOrderExcel = useDownloadData(`order/generate-excel-sales-order/${id}`, true);
    const downloadPackingListPDF = useDownloadData(`order/generate-pdf-packing-list/${id}`, true);
    const downloadInvoiePDF = useDownloadData(`order/generate-pdf-commercial-invoice/${id}/`, true);

    const updateOrder = useUpdateData(`${resource_path}`);
    const createOrder = useCreateData(`${resource_path}`);
    const calculateTaxes = useUpdateData('tax/order-tax-calculation/calculate');

    const duplicateOrder = useCreateData(`order/sales-order/${id}/duplicate-order`);

    const handleDuplicateOrder = () => {
        duplicateOrder.mutate(id);
    };

    const handleCalculateTaxes = () => {
        calculateTaxes.mutate({ id });
    };

    const [formData, setFormData] = useState({});
    const [paymentTermTemplate, setPaymentTermTemplate] = useState(null);
    const [showManualPaymentTerms, setShowManualPaymentTerms] = useState(false);
    const handleInputChange = (e) => (getInputChange(e, formData, setFormData));

    const handlePaymentTermTemplateChange = (template) => {
        setPaymentTermTemplate(template);

        // Check if "Other" option is selected
        if (template?.isOther || template?.id === null) {
            // Other option: clear both template and terms, show manual field for fresh input
            setFormData(prev => ({
                ...prev,
                payment_term_template: null,
                payment_terms: ''
            }));
            setShowManualPaymentTerms(true);
        } else if (template) {
            // Template selected: set template ID and name, hide manual field
            setFormData(prev => ({
                ...prev,
                payment_term_template: template.id,
                payment_terms: template.name
            }));
            setShowManualPaymentTerms(false);
        } else {
            // No selection: clear both, show manual field
            setFormData(prev => ({
                ...prev,
                payment_term_template: null,
                payment_terms: ''
            }));
            setShowManualPaymentTerms(true);
        }
    };

    const handleTusAdditionsChange = (e) => {
        const additionsValue = parseInt(e.target.value);
        const updatedFormData = { ...formData, tus_additions: additionsValue };

        // Set the TUS value based on selected additions
        if (additionsValue && tusRates) {
            const selectedRate = tusRates.find(rate => rate.additions === additionsValue);
            if (selectedRate) {
                updatedFormData.tus = selectedRate.value;
            }
        }

        setFormData(updatedFormData);
    };

    // Set form data when order loads (only on initial load, not on refetch)
    useEffect(() => {
        if (isEditMode && order && !formData.id) {
            // Only set formData if it's empty (initial load)
            setFormData(() => order);
            // Set payment term template state
            if (order.payment_term_template) {
                setPaymentTermTemplate(order.payment_term_template);
                setShowManualPaymentTerms(false);
            } else {
                setPaymentTermTemplate(OTHER_OPTION);
                setShowManualPaymentTerms(true);
            }
        }
    }, [order, isEditMode]);

    useEffect(() => {
        if (!isEditMode && statusSalesOrder?.length && !formData.status_id) {
            const openStatus = statusSalesOrder.find(status => status.status === 'Open');
            if (openStatus) {
                setFormData(prev => ({ ...prev, status_id: openStatus.id }));
            }
        }
    }, [isEditMode, statusSalesOrder, formData.status_id]);

    useEffect(() => {
        // navigate to the new order after duplicate
        if (duplicateOrder.isSuccess) {
            toast.success('Order duplicated successfully.');
            navigate(`/admin/order/sales-order/edit/${duplicateOrder.data.id}`)
        }
    }, [duplicateOrder.isSuccess, navigate, duplicateOrder.data?.id]);

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSave = () => {
        isEditMode ? updateOrder.mutate({ id, newData: formData }) : createOrder.mutate(formData);
    };

    useEffect(() => {
        if (createOrder.isSuccess) {
            // navigate("/admin/order/sales-order/tracking/");
            navigate(`/admin/order/sales-order/edit/${createOrder.data.id}`)
        }
    }, [updateOrder.isSuccess, createOrder.isSuccess, navigate, createOrder.data?.id, isEditMode]);

    const handleOrderExcelDownload = () => {
        downloadOrderExcel.mutate('myDownloadedFile.pdf');
    };

    useEffect(() => {
        refetchOrderFiles();
    }, [downloadOrderExcel.isSuccess]);

    useEffect(() => {
        refetchPackingFiles();
    }, [downloadPackingListPDF.isSuccess]);

    useEffect(() => {
        refetchInvoiceFiles();
    }, [downloadInvoiePDF.isSuccess]);

    const handleOrderPackingListPDFDownload = () => {
        downloadPackingListPDF.mutate('myDownloadedFile.pdf');
    };

    const handleOrderInvoicePDFDownload = () => {
        downloadInvoiePDF.mutate('myDownloadedFile.pdf');
    };

    if (isLoadingClients || isLoadingShippers || isLoadingStatusSalesOrder || isLoadingOrder || isLoadingUsers || isLoadingOrderTypes || isLoadingTusRates) {
        return <div>Loading...</div>;
    }
    if (errorClients || errorShippers || errorStatusSalesOrder || errorOrder || errorUsers || errorOrderTypes || errorTusRates) {
        return <div>Error...</div>;
    }

    const discontinuedStatusId = statusSalesOrder.find(status => status.status === 'Discontinued')?.id;

    const formFields = [
        // 1. Order Creation Section
        {
            id: "buyer_id",
            label: "Client",
            type: "select",
            options: clients?.map(client => ({ value: client.id, label: client.social_reason })),
            mdColSpan: 6,
            handleInputChange,
            value: formData?.buyer_id,
            disabled: isEditMode
        },
        {
            id: "order_identifier",
            label: "Order Identifier",
            type: "text",
            mdColSpan: 3,
            handleInputChange,
            value: formData?.order_identifier
        },
        {
            id: "order_type",
            label: "Order Type",
            mdColSpan: 3,
            type: "select",
            options: orderTypes?.map(orderType => ({ value: orderType.value, label: orderType.label })) || [],
            handleInputChange,
            value: formData?.order_type
        },
        {
            id: "status_id",
            label: "Order Status",
            type: "select",
            options: statusSalesOrder.map(status => ({ value: status.id, label: status.status })) || [],
            mdColSpan: 6,
            handleInputChange,
            value: formData?.status_id
        },
        {
            id: "issue_date",
            label: "Issue Date",
            type: "date",
            disabled: true,
            default: dayjs(new Date()).format("YYYY-MM-DD"),
            mdColSpan: 3,
            handleInputChange,
            value: formData?.issue_date
        },

        {
            id: "customer_ref",
            label: "Customer Reference",
            type: "text",
            mdColSpan: 3,
            handleInputChange,
            value: formData?.customer_ref
        },
        {
            id: "assigned_to",
            label: "Assigned To",
            type: "select",
            options: users
                ?.filter(user => user.is_active && (user.is_staff || user.is_superuser))
                .map(user => ({ value: user.id, label: user.name })) || [],
            mdColSpan: 4,
            handleInputChange,
            value: formData?.assigned_to
        },
        {
            id: "sales_rep_assigned_to",
            label: "Sales Representative",
            type: "select",
            options: users
                ?.filter(user => user.is_active && (user.is_staff || user.is_superuser))
                .map(user => ({ value: user.id, label: user.name })) || [],
            mdColSpan: 4,
            handleInputChange,
            value: formData?.sales_rep_assigned_to
        },
        {
            id: "shipper",
            label: "Shipper",
            type: "select",
            options: shippers?.map(shipper => ({ value: shipper.id, label: shipper.social_reason })) || [],
            mdColSpan: 4,
            handleInputChange,
            value: formData?.shipper
        },

        // 3. Financial Section
        {
            id: "financial_section",
            type: "section",
            title: "Financial Information",
            mdColSpan: 12
        },
        {
            id: "payment_term_template",
            label: "Payment Terms Template",
            type: "custom",
            component: PaymentTermsAutocomplete,
            mdColSpan: 12,
            value: paymentTermTemplate,
            onChange: handlePaymentTermTemplateChange,
            error: false,
            helperText: ""
        },
        {
            id: "payment_terms",
            label: "Payment Terms (Manual)",
            placeholder: "eg. 100% in 30 days",
            type: "text",
            mdColSpan: 12,
            handleInputChange,
            value: formData?.payment_terms,
            showIf: () => showManualPaymentTerms
        },
        {
            id: "exchange_rate_dollar_to_real",
            label: "Dollar to Real",
            mdColSpan: 6,
            type: "number",
            handleInputChange,
            value: formData?.exchange_rate_dollar_to_real,
            inputProps: { step: 0.0001 }
        },
        {
            id: "forwarder_exchange_rate_usd_to_brl",
            label: "Forwarder Exchange Rate ($ to R$)",
            mdColSpan: 6,
            type: "number",
            handleInputChange,
            value: formData?.forwarder_exchange_rate_usd_to_brl,
            inputProps: { step: 0.0001 }
        },

        // 4. Tax Section
        {
            id: "tax_section",
            type: "section",
            title: "Tax Information",
            mdColSpan: 12
        },
        {
            id: "tus_additions",
            label: "TUS Additions",
            type: "select",
            options: tusRates?.map(rate => ({
                value: rate.additions,
                label: `${rate.additions} Addition${rate.additions !== 1 ? 's' : ''} - R$ ${rate.value}`
            })) || [],
            mdColSpan: (formData?.order_type === 'DISTRIBUTION' && isEditMode) ? 3 : 4,
            handleInputChange: handleTusAdditionsChange,
            value: formData?.tus_additions
        },
        {
            id: "advisory_fee",
            label: "Advisory Fee (R$)",
            mdColSpan: (formData?.order_type === 'DISTRIBUTION' && isEditMode) ? 3 : 4,
            type: "number",
            handleInputChange,
            value: formData?.advisory_fee
        },
        // Tax-section row layout by order type. markup_rate shows only for
        // Encomenda and Distribution (consumed by the distribution price
        // back-solve); advisory_fee_allocation_method is Encomenda-only.
        // Distribution is the only type that shows BOTH markup_rate and
        // commercial_agreement — four "wide" fields (tus, advisory_fee, markup,
        // commercial_agreement) that can't share one 12-col row at 4-span. So for
        // Distribution those four drop to 3-span: Row 1 = tus|advisory|markup|
        // commercial_agreement (4×3). Distribution also shows the importer tax
        // regime (not present on other types), so its fiscal rows tile as
        // province(6)|assessment(6), then client_regime(4)|importer_regime(4)|
        // fiscal-toggle(4) — each row summing to 12 with equal widths.
        // Encomenda/Advisory/C&O keep 4-span (markup hidden there, so
        // Row 1 holds only three wide fields). The 3-span is also gated on
        // isEditMode: commercial_agreement and the Row-2 fields are edit-only, so
        // in create mode only tus|advisory|markup show — they stay 4-span for a
        // clean three-across row instead of leaving a ragged 3+3+3 gap.
        {
            id: "markup_rate",
            label: "Taxa de Markup (%)",
            type: "percentage",
            mdColSpan: (formData?.order_type === 'DISTRIBUTION' && isEditMode) ? 3 : 4,
            handleInputChange,
            value: formData?.markup_rate,
            showIf: () => formData?.order_type === 'ORDER' || formData?.order_type === 'DISTRIBUTION'
        },
        {
            id: "advisory_fee_allocation_method",
            label: "Advisory Fee Allocation",
            type: "select",
            mdColSpan: 6,
            options: [
                { value: "POR_PROCESSO", label: "By Process" },
                { value: "POR_CONTAINER", label: "By Container" },
            ],
            handleInputChange,
            value: formData?.advisory_fee_allocation_method,
            showIf: () => formData?.order_type === 'ORDER'
        },
        {
            id: "commercial_agreement",
            label: "Commercial Agreement (%)",
            type: "percentage",
            allowNegative: true,
            // Span per order type (see the Tax-section row-layout note on
            // markup_rate above): Encomenda 6 (pairs with the allocation method,
            // 6+6); Distribution 3 (4-across Row 1 with tus|advisory|markup);
            // Advisory/C&O 4 (Row 1 next to tus+advisory_fee, all three 4-wide).
            mdColSpan: formData?.order_type === 'ORDER' ? 6
                : formData?.order_type === 'DISTRIBUTION' ? 3
                : 4,
            handleInputChange,
            value: formData?.commercial_agreement,
            helperText: formData?.order_type === 'ORDER'
                ? 'Para Encomenda, usar apenas para descontos financeiros. Ex.: -1.5 para -1,5%'
                : undefined,
            showIf: () => isEditMode
        },
        // Client/Importer fiscal row. Distribution edit mode adds a second regime
        // (importer_tax_regime) — six fields where the other types show four. To keep
        // every row a balanced 12-col budget without reordering the shared array
        // (which would shift the other types' layout), Distribution tiles as:
        // Row A = province(6)|assessment(6); Row B = client_regime(4)|importer_regime(4)|fiscal(4),
        // with the two regimes adjacent and equal-width. Non-distribution keeps the
        // pristine 4-across (province|assessment|regime|fiscal, all 3-span, importer hidden).
        {
            id: "client_province",
            label: "Province",
            type: "text",
            mdColSpan: (formData?.order_type === 'DISTRIBUTION' && isEditMode) ? 6 : 3,
            handleInputChange,
            value: formData?.client_province,
            showIf: () => isEditMode
        },
        {
            id: "client_assessment_type",
            label: "Assessment Type",
            type: "select",
            options: ASSESSMENT_TYPE_CHOICES,
            mdColSpan: (formData?.order_type === 'DISTRIBUTION' && isEditMode) ? 6 : 3,
            handleInputChange,
            value: formData?.client_assessment_type,
            showIf: () => isEditMode
        },
        {
            id: "client_tax_regime",
            label: formData?.order_type === 'DISTRIBUTION' ? "Client Tax Regime" : "Tax Regime",
            type: "select",
            options: TAX_REGIME_CHOICES,
            mdColSpan: (formData?.order_type === 'DISTRIBUTION' && isEditMode) ? 4 : 3,
            handleInputChange,
            value: formData?.client_tax_regime,
            showIf: () => isEditMode
        },
        {
            id: "importer_tax_regime",
            label: "Importer Tax Regime",
            type: "select",
            options: TAX_REGIME_CHOICES,
            mdColSpan: 4,
            handleInputChange,
            value: formData?.importer_tax_regime,
            showIf: () => formData?.order_type === 'DISTRIBUTION' && isEditMode
        },
        {
            id: "client_has_fiscal_benefit_ttd_409",
            label: "Has Fiscal Benefit TTD 409",
            type: "switch",
            mdColSpan: (formData?.order_type === 'DISTRIBUTION' && isEditMode) ? 4 : 3,
            handleInputChange,
            value: formData?.client_has_fiscal_benefit_ttd_409,
            helperText: "Indicates whether the client has fiscal benefits",
            showIf: () => isEditMode
        },

        // 5. Notes & Additional Details Section
        {
            id: "notes_section",
            type: "section",
            title: "Additional Information",
            mdColSpan: 12
        },
        {
            id: "additional_information",
            label: "Additional Information",
            type: "textarea",
            placeholder: "eg. Additional information about the order",
            mdColSpan: 12,
            cols: 30,
            mdCols: 1000,
            handleInputChange,
            value: formData?.additional_information
        },
        {
            id: "discontinued_reason",
            label: "Discontinued Reason",
            type: "textarea",
            mdColSpan: 12,
            showIf: () => {
                return formData?.status_id === discontinuedStatusId;
            },
            handleInputChange,
            value: formData?.discontinued_reason
        },
    ];

    return (
        // <div className="h-full w-full rounded-[20px] px-3 pt-7 md:px-8">
        <Grid container spacing={2} margin={2}>
            {/* Header */}
            <Grid container display="flex" justifyContent="space-between" xs={12}>
                <Grid>
                    <h4 className="pt-[5px] text-2xl font-bold text-navy-700 dark:text-white">
                        Order Info
                    </h4>
                </Grid>

                <Grid>
                    <Hidden lgDown>
                        <Button variant="contained" color="primary" onClick={handleSave}>
                            Save
                        </Button>
                    </Hidden>

                    <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
                        <MenuIcon />
                    </IconButton>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        PaperProps={{
                            style: {
                                width: isMobile ? '90%' : '40%', // Use 90% width on mobile screens, 40% otherwise
                                maxHeight: '300px',
                                overflow: 'auto'
                            }
                        }}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MenuList dense>
                            <MenuItem onClick={handleSave}>
                                <ListItemIcon>
                                    <Check />
                                </ListItemIcon>
                                <ListItemText primary="Save" />
                            </MenuItem>

                            <MenuItem onClick={toggleNotes}>
                                <ListItemIcon>
                                    <SpeakerNotesIcon />
                                </ListItemIcon>
                                <ListItemText primary="Notes" />
                            </MenuItem>

                            <Divider />
                            <MenuItem onClick={handleDuplicateOrder}>
                                <ListItemIcon>
                                    <ContentCopyIcon />
                                </ListItemIcon>
                                <ListItemText primary="Duplicate" />
                            </MenuItem>

                            <MenuItem onClick={handleCalculateTaxes}>
                                <ListItemIcon>
                                    <CalculateIcon />
                                </ListItemIcon>
                                <ListItemText primary="Calculate Taxes" />
                            </MenuItem>

                            <Divider />
                            <MenuItem onClick={handleOrderExcelDownload}>
                                <ListItemIcon>
                                    <DownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Download Excel" />
                            </MenuItem>
                            <MenuItem onClick={handleOrderPackingListPDFDownload}>
                                <ListItemIcon>
                                    <DownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Packing List" />
                            </MenuItem>

                            <MenuItem onClick={handleOrderInvoicePDFDownload}>
                                <ListItemIcon>
                                    <DownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Invoice" />
                            </MenuItem>

                        </MenuList>
                        {(orderFiles?.length > 0 || packingFiles?.length > 0 || invoiceFiles?.length > 0) && (
                            <>
                                <Divider />
                                <SimpleTreeView>
                                    {orderFiles?.length > 0 && (
                                        <TreeItem itemId="gridOrderFiles" label="Excel Files">
                                            {orderFiles?.map(file => (
                                                <TreeItem
                                                    itemId={file.id}
                                                    slots={{ icon: DownloadIcon }}
                                                    label={file.file_name} onClick={handleOrderExcelDownload} />
                                            ))}
                                        </TreeItem>
                                    )}
                                    {packingFiles?.length > 0 && (
                                        <TreeItem itemId="gridPackingFiles" label="Packing List">
                                            {packingFiles?.map(file => (
                                                <TreeItem
                                                    itemId={file.id}
                                                    slots={{ icon: DownloadIcon }}
                                                    label={file.file_name}
                                                    onClick={handleOrderPackingListPDFDownload} />
                                            ))}
                                        </TreeItem>
                                    )}
                                    {invoiceFiles?.length > 0 && (
                                        <TreeItem itemId="gridInvoiceFiles" label="Invoice">
                                            {invoiceFiles?.map(file => (
                                                <TreeItem
                                                    itemId={file.id}
                                                    slots={{ icon: DownloadIcon }}
                                                    label={
                                                        <Typography variant="body2" color="text.secondary">
                                                            {file.file_name}
                                                        </Typography>
                                                    }
                                                    onClick={handleOrderInvoicePDFDownload}
                                                />
                                            ))}
                                        </TreeItem>
                                    )}

                                </SimpleTreeView>
                            </>
                        )}
                    </Menu>
                    <FullScreenDialog open={showNotes} onClose={toggleNotes} sales_order_id={id} />

                </Grid>

            </Grid>
            {/* content */}
            {/* inputs */}
            <Grid container spacing={2}>
                {formFields.map(field => {
                    // Handle custom field type (PaymentTermsAutocomplete)
                    if (field.type === 'custom' && field.component) {
                        const CustomComponent = field.component;
                        return (
                            <Grid key={field.id} xs={12} md={field.mdColSpan || 4}>
                                <FormControl fullWidth margin='dense'>
                                    <CustomComponent
                                        value={field.value}
                                        onChange={field.onChange}
                                        error={field.error}
                                        helperText={field.helperText}
                                    />
                                </FormControl>
                            </Grid>
                        );
                    }
                    return (
                        <DynamicFormField
                            key={field.id}
                            field={field}
                            formData={formData}
                            handleInputChange={handleInputChange}
                        />
                    );
                })}
            </Grid>
        </Grid >
    );
}

export default OrderSale